<template>
  <el-drawer :wrapperClosable="false" :visible.sync="dialogVisble" size="480px" :show-close="false" destroy-on-close>
    <template #title>
      <div style="height: 50px">
        <div class="staff_head">
          <div class="staff_l">
            <img src="@/assets/structure/close.png" class="staff_close" @click="handleClose" />
            <div>访客审核</div>
          </div>
          <div style="text-align: right;">
            <el-button type="warning" @click="handleReject">拒绝</el-button>
            <el-button type="primary" @click="handleAgree">通过</el-button>
          </div>
        </div>
      </div>
    </template>
    <div style="padding:0 20px;">
      <el-form :model="form" :rules="rules" :disabled="true">
        <el-row :gutter="20">
          <el-col :span="24" v-if="form.photoBase64">
            <el-form-item label="" prop="photoBase64">
              <el-image
                  style="width: 100px; height: 100px;border-radius: 50%"
                  :src="'data:image/jpeg;base64,'+form.photoBase64"
                  :preview-src-list="['data:image/jpeg;base64,'+form.photoBase64]">
              </el-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="访客姓名" prop="visitor">
              <el-input v-model="form.visitor"/>
            </el-form-item>
            <el-form-item label="访客性别" prop="sex">
              <el-input v-model="form.sex"/>
            </el-form-item>
            <el-form-item label="访客手机号" prop="phoneNum">
              <el-input v-model="form.phoneNum"/>
            </el-form-item>

            <el-form-item label="访问时间" prop="visitDate">
              <el-input v-model="form.visitDate"/>
            </el-form-item>
            <el-form-item label="车牌号" prop="plateNum">
              <el-input v-model="form.plateNum"/>
            </el-form-item>
            <el-form-item label="访问事由" prop="reason">
              <el-input type="textarea" v-model="form.reason"/>
            </el-form-item>
            <el-form-item label="被访人" prop="user">
              <el-input v-model="form.user.name"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="访客身份证号" prop="idno">
              <el-input v-model="form.idno"/>
            </el-form-item>
            <el-form-item label="设备编号" prop="deviceNumber">
              <el-input v-model="form.deviceNumber"/>
            </el-form-item>
            <el-form-item label="访客工作单位" prop="visitorCompanyName">
              <el-input v-model="form.visitorCompanyName"/>
            </el-form-item>
            <el-form-item label="预计离访时间" prop="visitEndDate">
              <el-input v-model="form.visitEndDate"/>
            </el-form-item>
            <el-form-item label="随行人数" prop="personCnt">
              <el-input v-model="form.personCnt"/>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" v-model="form.remark"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-dialog
        :show-close="false"
        :visible.sync="agreeDialogVisible"
        width="30%"
        append-to-body>
      <div class="diglog_h">
        <div>同意审批</div>
        <img  src="@/assets/structure/close.png"
            class="diglog_icon"
            @click="agreeDialogVisible=false"
        />
      </div>
      <div style="padding: 20px;">
        <el-form :model="agreeForm" :rules="agreeRules" ref="agreeFormRef">
          <el-form-item label="访客姓名" prop="visitor">
            <el-input v-model="form.visitor"/>
          </el-form-item>
          <el-form-item label="访客性别" prop="sex">
            <el-input v-model="form.sex"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agreeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="agreeDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog
        :show-close="false"
        :visible.sync="rejectDialogVisible"
        width="30%"
        append-to-body>
      <div class="diglog_h">
        <div>拒绝审批</div>
        <img  src="@/assets/structure/close.png"
              class="diglog_icon"
              @click="rejectDialogVisible=false"
        />
      </div>
      <div style="padding: 20px;">
        <el-form :model="rejectForm" :rules="rejectRules" ref="rejectFormRef">
          <el-form-item label="拒绝理由" prop="reason">
            <el-input type="textarea" v-model="rejectForm.reason" rows="5" placeholder="请输入拒绝理由"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="rejectLoading" @click="handleSubmitReject">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        :show-close="false"
        :visible.sync="agreeDialogVisible"
        width="760px"
        append-to-body>
      <div class="diglog_h">
        <div>通过审批</div>
        <img  src="@/assets/structure/close.png"
              class="diglog_icon"
              @click="agreeDialogVisible=false"
        />
      </div>
      <div style="padding: 20px;text-align: center">
        <el-form :model="agreeForm" :rules="agreeRules" ref="agreeFormRef">
          <el-form-item  prop="deviceList">
            <el-transfer
                style="text-align: left; display: inline-block"
                class="audit-device-transfer"
                v-model="agreeForm.deviceList"
                filterable
                :left-default-checked="[]"
                :right-default-checked="[]"
                :titles="['未选择设备', '已选择设备']"
                :props="{
                  key: 'id',
                  label: 'name'
                }"
                :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
                }"
                :data="deviceList">
              <div slot-scope="{ option }" :class="option.disabled ? 'offline' : 'online'">
                <div class="option_label">
                  <span>{{ option.name }}</span>
                  <span style="color: #b2b2b2;margin-left: 5px;">({{ option.sn }})</span>
                </div>
              </div>
            </el-transfer>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agreeDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="agreeLoading" @click="handleSubmitAgree">确 定</el-button>
      </span>
    </el-dialog>
  </el-drawer>
</template>

<script>
import DrawerHeader from "@/components/drawerHeader.vue"
import {VisitorApplyApi} from '@/api/server/visitorApply';
import {DmsDeviceApi} from "@/api/server/dmsDevice";
export default {
  name: "Audit",
  components: {
    DrawerHeader
  },
  data() {
    return {
      dialogVisble: false,
      submitLoading: false,
      form: {
        user: {},
      },
      rules: {
      },
      deviceList: [],
      agreeDialogVisible: false,
      agreeLoading: false,
      agreeForm: {
        deviceList: []
      },
      agreeRules: {
        deviceList: [{
          required: true,
          message: '请选择设备',
          trigger: 'change'
        }]
      },
      renderFunc(h, option) {
        return <span>{ option.name } - { option.sn }</span>;
      },
      rejectLoading: false,
      rejectDialogVisible: false,
      rejectForm: {
        id: null,
        reason: null
      },
      rejectRules: {
        reason: [{
          required: true,
          message: '请输入拒绝理由',
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {

    queryDeviceList(){
      const params = {
        allowVisitor: true
      }
      DmsDeviceApi.queryDmsDeviceList(params).then(response => {
        this.deviceList = response.data;
      })
    },
    //关闭抽屉
    handleClose() {
      this.dialogVisble = false;
    },
    //打开对话框
    async show(row) {
      this.form = Object.assign({}, row);
      this.dialogVisble = true
      this.queryDeviceList();
    },
    handleAgree(){
      this.agreeForm = {
        id: this.form.id,
        deviceList: []
      }
      this.agreeDialogVisible = true
    },
    handleReject(){
      this.rejectForm = {
        id: this.form.id,
        reason: null
      }
      this.rejectDialogVisible = true
    },
    handleSubmitReject(){ //提交拒绝审核
      this.$refs.rejectFormRef.validate(valid => {
        if(valid){
          this.rejectLoading = true;
          let data = {
            id: this.form.id,
            reason: this.rejectForm.reason
          }
          VisitorApplyApi.rejectApproval(data).then(response => {
            const {code,data,message} = response;
            if(code == 200){
              this.$message.success(message || '操作成功');
              this.rejectDialogVisible = false;
              this.dialogVisble = false;
              this.$emit('success');
            }else{
              this.$message.error(message || '拒绝审批失败');
            }
          }).finally(() => {
            this.rejectLoading = false;
          })
        }
      })
    },
    handleSubmitAgree(){
      this.$refs.agreeFormRef.validate(valid => {
        if(valid){
          this.agreeLoading = true;
          let data = {
            id: this.form.id,
            deviceList: this.agreeForm.deviceList
          }
          VisitorApplyApi.agreeApproval(data).then(response => {
            const {code,data,message} = response;
            if(code == 200){
              this.$message.success(message || '操作成功');
              this.agreeDialogVisible = false;
              this.dialogVisble = false;
              this.$emit('success');
            }else{
              this.$message.error(message || '通过审批失败');
            }
          }).finally(() => {
            this.agreeLoading = false;
          })
        }
      })
    }
  }
}
</script>

<style>
.audit-device-transfer {
  --el-transfer-panel-width: 450px;
  --el-transfer-panel-body-height: 400px;
}
.audit-device-transfer .el-transfer-panel {
  width: 370px !important;
}
.audit-device-transfer .online::after {
  margin-left: 10px;
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  width: 8px;
  height: 8px;
  background: #1ab137;
  border-radius: 50%;
}

.audit-device-transfer .offline::after {
  margin-left: 10px;
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  width: 8px;
  height: 8px;
  background: #ff0000;
  border-radius: 50%;
}
.audit-device-transfer .option_label{
  margin-left: 11px;
}
</style>